import React, { useState } from 'react';
import useFilterPopup from '../../../../hooks/useFilterPopup';
import { SetFiltersValues } from '../../types';
import {
  formatChangedPriceValue,
  normalizePriceValue,
} from '../../../Search/utils/listingsFiltersUtils';
import ControlledInput from 'components/common/ControlledInput';
import { ANY } from 'constants/building/availableCondos';

interface Props {
  min: string;
  max: string;
  setValues: SetFiltersValues;
}

const SquareFeet: React.FC<Props> = ({ min, max, setValues }) => {
  const { values } = useFilterPopup({
    onChange,
    initialValues: { min, max },
    isReloadOnBlur: true,
  });

  const [localMinValue, setLocalMinValue] = useState(values.min);
  const [localMaxValue, setLocalMaxValue] = useState(values.max);

  function onChange(values: { min: string; max: string }) {
    setValues((prevValues) => ({ ...prevValues, sqft: values }));
  }

  const handleBlur = () => {
    onChange({ min: localMinValue, max: localMaxValue });
  };

  return (
    <div className="md:w-1/2">
      <label htmlFor="" className="md:text-14-26-0.3">
        Square Feet
      </label>
      <div className="flex mt-0 align-center leading-[21px]">
        <ControlledInput
          className="flex-1 min-w-[0px] md:w-[137px] md:flex-none pt-[6px] pb-[7px] pl-[16px] h-[44px] px-4 py-2 border border-beige-dark text-black"
          type="text"
          inputMode="decimal"
          placeholder="Min"
          value={normalizePriceValue(localMinValue)}
          onChange={({ target }) =>
            target.value
              ? setLocalMinValue(formatChangedPriceValue(target.value))
              : setLocalMinValue(ANY)
          }
          onBlur={handleBlur}
        />
        <div className="self-center mt-[5px] w-[10px] mx-[10px] md:px-0 md:w-[8px] md:mx-[8px] bg-beige border" />
        <ControlledInput
          className="flex-1 min-w-[0px] md:w-[137px] md:flex-none pt-[6px] pb-[7px] pl-[16px] h-[44px] px-4 py-2 border border-beige-dark text-black"
          type="text"
          inputMode="decimal"
          placeholder="Max"
          value={normalizePriceValue(localMaxValue)}
          onChange={({ target }) => {
            target.value
              ? setLocalMaxValue(formatChangedPriceValue(target.value))
              : setLocalMaxValue(ANY);
          }}
          onBlur={handleBlur}
        />
      </div>
    </div>
  );
};

export default SquareFeet;
